import isEqual from "lodash/isEqual";
import { DependencyList, EffectCallback, useCallback, useRef } from "react";

function deepCompareEquals(a: unknown, b: unknown) {
  return isEqual(a, b);
}

function useDeepCompareMemoize(value: DependencyList) {
  const ref = useRef<DependencyList>([]);

  // it can be done by using useMemo as well
  // but useRef is rather cleaner and easier
  if (!deepCompareEquals(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

/**
 * @deprecated Do not use it in the new lists code base. It was used for operation states and fetching data - right now RTK Query cares about caching and status flags
 */
export function useDeepCompareCallback(
  callback: EffectCallback,
  dependencies: DependencyList
) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(callback, useDeepCompareMemoize(dependencies));
}
